import { AppBar as RaAppBar } from 'react-admin'
import UserMenu from './user-menu'
import {
  Typography,
  Box,
  Grid,
} from '@mui/material'
import { useSettings } from '../../hooks'

const AppBar = props => {
  const { tenantName } = useSettings()

  return (
    <RaAppBar
      {...props}
      userMenu={<UserMenu />}
      container={Box} // override Slide effect - keep fixed
    >
      <Grid container flex={1} wrap='nowrap' alignItems='center' spacing={2} sx={{ overflow: 'hidden'}}>
        <Grid item sx={{ width: { md: 165, xs: 0 } }}>
          <Typography
            variant='h6'
            color='inherit'
            id='react-admin-title'
            sx={{
              margin: 0,
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textTransform: 'capitalize',
            }}
          />
        </Grid>
        <Grid item flex={1} sx={{ overflow: 'hidden' }}>
          <Typography
            variant='h6'
            color='inherit'
            sx={{
              margin: 'auto',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textAlign: 'center',
              textTransform: 'capitalize',
            }}
          >
            {tenantName}
          </Typography>
        </Grid>
      </Grid>
    </RaAppBar>
  )
}

export default AppBar

